/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { baseRequest } from './baseRequest';
const baseRoute = '/api/internal/title';
export const getTitleOrderByLoanId = async loanId => {
  return baseRequest.get(`${baseRoute}/orders`, {
    params: {
      loanId
    }
  });
};
export const getTitleOrderAndActivitiesByLoanId = async loanId => {
  return baseRequest.get(`${baseRoute}/order-activities`, {
    params: {
      loanId
    }
  });
};
export const updateTitleOrder = async (orderId, tenant, body) => {
  return baseRequest.patch(`${baseRoute}/orders/${orderId}`, {
    body,
    tenant
  });
};
export const getLiens = async (orderId, tenant) => {
  return baseRequest.get(`${baseRoute}/orders/${orderId}/liens`, {
    params: {
      tenant
    }
  });
};
export const getTaxes = async (orderId, tenant) => {
  return baseRequest.get(`${baseRoute}/orders/${orderId}/taxes`, {
    params: {
      tenant
    }
  });
};
export const getTitleCuratives = async (orderId, tenant) => {
  return baseRequest.get(`${baseRoute}/orders/${orderId}/curatives`, {
    params: {
      tenant
    }
  });
};
export const updateLienDoc = async (orderId, lienId, docId, tenant) => {
  return baseRequest.patch(`${baseRoute}/orders/${orderId}/liens/${lienId}/doc`, {
    docId,
    tenant
  });
};
export const updateTaxDoc = async (orderId, taxId, docId, tenant) => {
  return baseRequest.patch(`${baseRoute}/orders/${orderId}/taxes/${taxId}/doc`, {
    docId,
    tenant
  });
};
export const putTitleCuratives = async (orderId, tenant, data) => {
  return baseRequest.put(`${baseRoute}/orders/curatives`, {
    orderId,
    tenant,
    ...data
  });
};
export const getFeesImport = async (applicationId, tenant) => {
  return baseRequest.get(`${baseRoute}/fees/import`, {
    params: {
      applicationId,
      tenant
    }
  });
};